import React, { useState, useEffect, ReactNode } from 'react'
import { Services } from '@/services/services'
import { Translates } from '@/services/repository/i18n'
import { CurrentSession } from '@/services/repository/session'
import { LoggedInLayout, LoggedInPageLayout } from './LoggedInLayout'
import { CommunalLayout, CommunalPageLayout } from './CommunalLayout'
import { NavigationRow } from './Navigation'
import { InnerLayout } from './InnerLayout'

export interface MainLayoutParams {
  pageName: string
  services: Services
  translates: Translates | undefined
  session?: CurrentSession
  children: ReactNode
  path?: NavigationRow[]
  navbarLeft?: ReactNode
  navbarRight?: ReactNode
}

export const MainLayout = (params: MainLayoutParams) => {
  const translates = params.translates
  if(translates===undefined) {
    return <div className='spinner'></div>
  }
  if (params.session !== undefined) {
    return <LoggedInLayout {...params} session={params.session} />
  }
  return <CommunalLayout {...params} translates={translates}/>
}

export const MainPageLayout = (params: MainLayoutParams) => {
  if (params.session !== undefined) {
    return <LoggedInPageLayout {...params} session={params.session} path={params.path} />
  }
  return <InnerLayout {...params} path={params.path} />
}